// A money text input that never reformats while you type. While focused it shows exactly what was typed or pasted
// ("6,083.98", "6083.98", "$6,083.98") and reports the cleaned number string ("6083.98") on every keystroke; the
// caller's formatted `value` is shown again only once the field loses focus.
//
// ⛔ WHY: an input whose value is re-formatted on every keystroke fights the typist. The installment card rendered
// value={fmtMoneyIn(stored)}, so typing "6" became "6.00" at once, every later digit landed after the decimal point,
// and 6,083.98 ended up as "6.01". Formatting belongs on blur, never on change.
import React, { useState } from 'react';

// "$6,083.98" → "6083.98". Same rule the card's stores already applied (digits and the decimal point only).
export const cleanMoney = (text) => String(text ?? '').replace(/[^0-9.]/g, '');

export default function MoneyInput({ value, onChange, onBlur, ...rest }) {
  const [draft, setDraft] = useState(null);   // the typed text while focused; null = show `value`
  return (
    <input type="text" inputMode="decimal" {...rest}
      value={draft != null ? draft : (value ?? '')}
      onFocus={e => { setDraft(value ?? ''); rest.onFocus && rest.onFocus(e); }}
      onChange={e => { setDraft(e.target.value); onChange(cleanMoney(e.target.value), e.target.value); }}
      onBlur={e => { setDraft(null); onBlur && onBlur(e); }} />
  );
}
